import { Tabs } from '@mantine/core';
import { useLocation, useNavigate } from 'react-router-dom';
import { AiOutlineAppstore, AiOutlineClockCircle } from 'react-icons/ai';

export const BillingTabs = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const activeTab = location.pathname.startsWith('/subscriptions') ? 'subscriptions' : 'products';

    return (
        <Tabs value={activeTab} onChange={(value) => navigate(value === 'subscriptions' ? '/subscriptions' : '/products')} mb="lg">
            <Tabs.List>
                <Tabs.Tab value="products" leftSection={<AiOutlineAppstore size="1.2em" />}>Products & Plans</Tabs.Tab>
                <Tabs.Tab value="subscriptions" leftSection={<AiOutlineClockCircle size="1.2em" />}>My Subscriptions</Tabs.Tab>
            </Tabs.List>
        </Tabs>
    );
};
